<app-authentication></app-authentication>
<div class="clearfix"></div>
<div class="container-fluid px-0">
  <div class="main-row">                
         <div class="modal fade" id="add-department" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable text-body">
                  <div class="modal-content">
                      <div class="modal-header border-0">
                          <h5 class="modal-title" id="exampleModalLabel">My Section</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <form>
                          <div class="modal-body">
                              <div class="form-group search">
                                  <button class="border-0 bg-transparent pl-3">
                                      <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-search" fill="#717173" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"></path>
                                          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"></path>
                                      </svg>
                                  </button>
                                  <input type="text" class="form-control bg-light border-0 pl-5" id="inputTilename" placeholder="Search..">
                              </div>
                              <div class="form-group">
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                                    <label class="form-check-label" for="defaultCheck1">
                                      DEWA Website
                                    </label>
                                  </div>
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                                    <label class="form-check-label" for="defaultCheck2">
                                      DEWA Website
                                    </label>
                                  </div>
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                                    <label class="form-check-label" for="defaultCheck2">
                                      DEWA Website
                                    </label>
                                  </div>
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                                    <label class="form-check-label" for="defaultCheck2">
                                      DEWA Website
                                    </label>
                                  </div>
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                                    <label class="form-check-label" for="defaultCheck2">
                                      DEWA Website
                                    </label>
                                  </div>
                                  <div class="form-check border-bottom py-2">
                                    <input class="form-check-input" type="checkbox" value="" id="defaultCheck2">
                                    <label class="form-check-label" for="defaultCheck2">
                                      DEWA Website
                                    </label>
                                  </div>

                              </div>
                          </div>
                          <div class="modal-footer border-0">
                              <button type="button" class="btn btn-white border" data-dismiss="modal">Remove Section</button>
                              <button type="submit" class="btn btn-primary">Save</button>
                          </div>
                      </form>
                  </div>
              </div>
          </div>      
      <main role="main" class="ml-sm-auto p-0 bg-light main-container">        
          <div class="main-content container-fluid col-lg-12">
              <div class="row">
                  <div class="col-lg-12">
                      <h4 class="font-weight-bold text-lightdark my-3">Recently Used</h4>
                      <h5 class="font-weight-light text-lightdark my-3">No recent activity</h5>
                  </div>
              </div>

              <div class="row">
                  <div class="col-lg-12">
                      <h4 class="font-weight-bold text-lightdark my-3">Add Section 
                        <!-- {{'MENU.LINE1_SUB' | translate}} -->
                        <a type="button" class="text-nowrap mt-5 " data-toggle="modal" data-target="#add-department">
                          <img src="../../mw/assets/img/add-dark.png" height="24" class="mr-3"> 
                          </a></h4>
                      <h5 class="font-weight-light text-lightdark my-3">You can create your own section with personalised items
                        <!-- {{'MENU.SUB_SEC_DESC' | translate}} -->
                      </h5>
                  </div>
              </div>
          </div>
      </main>
  </div>
</div>

